export default __webpack_public_path__ + "b3bbb02f0b107522eb98b8bd27d98bf9.svg";